import React, { useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { SecondaryHeader as StyledSecondaryHeader } from '../../ContentSystem.shared.styles';
import { ContainerQueryContext } from '../../../../util/ContainerQuery.context';
/**
 * Represents the secondary header component of the content system.
 *
 * @component
 * @param lightHexCode - The hex code for the light color of the header. Defaults to white.
 * @param children - The content to be rendered inside the SecondaryHeader.
 */
var SecondaryHeader = function (_a) {
    var lightHexCode = _a.lightHexCode, children = _a.children;
    var typography = useContext(ThemeContext).typography;
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    return (React.createElement(StyledSecondaryHeader, { lightHexCode: lightHexCode, styleSettings: typography === null || typography === void 0 ? void 0 : typography.secondaryHeader, "$styleQueryMode": styleQueryMode }, children));
};
export default SecondaryHeader;
